import { render } from "./CompanyPage.vue?vue&type=template&id=a574f500&scoped=true"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"

import "./CompanyPage.vue?vue&type=style&index=0&id=a574f500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a574f500"]])

export default __exports__